<template>
    <div
        class="form-separator flex-fill"
        :class="{ collapsed: collapsed }"
    >
        <hr />
        <div>
            <span
                :class="{ 'me-0': icon }"
                :style="iconStyle"
                >{{ $tm(modelValue) }}</span
            >
            <IconComp
                v-if="icon"
                :icon="icon"
                class="float-end mt-1"
            />
        </div>
    </div>
</template>
<script setup lang="ts">
import { computed } from 'vue';
import { IconComp } from '..';

const iconStyle = computed(() => (props.icon ? 'padding-right: 0 !Important;' : ''));

/**
 * Since we are handling the separator as a component we need to have the correct signature
 * with props and exposes.
 * Modelvalue will contain the separator string = translation key
 */
const props = withDefaults(
    defineProps<{
        modelValue: string;
        value?: string | null;
        icon?: string | null;
        collapsed?: boolean;
    }>(),
    { value: null },
);

defineExpose({ focus: () => {} });
</script>
